module.exports = __webpack_public_path__ + "static/img/bg_chongzhi_bang_1.b6d8d80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_chongzhi_bang_1.png
// module id = nQBJ
// module chunks = 0